<template>
  <Modal @close="$emit('close')" width="720px">

    <div class="existing-order__list">
      <div v-for="(item, i) in items" 
        :key="'item' + i"
        class="existing-order__item"
      >
        <div class="existing-order__title">Внимание</div>
        <div class="existing-order__text">
          На сотрудника 
          {{`${item.surname || ""} ${item.name || ""} ${item.patronymic || ""}`}} 
          уже создана 
          <a class="existing-order__link"
            :href="`/order/read/${item.id}`"
            target="_blank"
          >
            заявка № {{ item.number }}
          </a>
        </div>
      </div>
    </div>

      <div class="button__wraper">
        <Button
          @click="$emit('save')"
          :loading="loading"
          class="btn-primary"
          width="190px"
          height="40px"
          text="Все равно сохранить"
        />
        <Button
          class="btn-secondary"
          width="96px"
          height="40px"
          text="Отмена"
          @click="$emit('close')"
        />
      </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modals/Modal.vue";
import Button from "@/components/Button.vue";

export default {
  components: {
    Button,
    Modal
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.existing-order {
  &__list {
    max-height: 400px;
    overflow: auto;
    padding-bottom: 30px;

    &::-webkit-scrollbar {
      width: 8px;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 66, 105, 0.06);
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 66, 105, 0.24);
      border-radius: 4px;
    }
  }

  &__item {
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 32, 51, 0.04), 0px 8px 24px rgba(0, 32, 51, 0.12);
    border-radius: 8px;
    padding: 12px 24px 30px 24px;
    margin: 0 20px 30px 20px;
    // width: 100%;
    overflow: hidden;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      content: '';
      width: 8px;
      height: 100%;
      background: #F38B00;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  &__title {
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
    color: #002033;
    margin-bottom: 4px;
  }

  &__text {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
  }

  &__link {
    color: #0078D2;
    text-decoration: underline;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      color: #008EFA;
      text-decoration: none;
    }
  }
}

.button__wraper {
  margin-top: 30px;
}

</style>
